import React from 'react';
import { cpmSlugCustomizationShape } from 'constants/PropTypesShapes';

const CheckoutHeader = ({ customization: { logo, title } }) => {
  const Logo = logo ? <img src={logo} className="company-logo company-logo__checkout mb-2" alt="Company Logo" /> : null;
  const Title = title ? <div className="checkoutTitle text-center">{title}</div> : null;

  return (
    <div className="d-flex flex-column align-items-center mb-5">
      {Logo}
      {Title}
    </div>
  );
};

CheckoutHeader.propTypes = {
  customization: cpmSlugCustomizationShape,
};

CheckoutHeader.defaultProps = {
  customization: null,
};

module.exports = CheckoutHeader;



// WEBPACK FOOTER //
// ./routes/checkout/assets/CheckoutHeader.js